import React from 'react';
import Download from '../assets/img/download-red20.png';
import PDF1 from '../assets/downloads/Px GCSF PDF DEC 2017.pdf';
import PDF2 from '../assets/downloads/NH Publications on Unstable Haemoglobin diseases.pdf';
import PDF3 from '../assets/downloads/AISWAL_et_al_Cytotherapy2017_onlyCD56-enriched donor cell infus.pdf';
import PDF4 from '../assets/downloads/Rel-Poster Dr. Bansal Mumbai.pdf';
import PDF5 from '../assets/downloads/Outcome_in_allogeneic_T_cell_depleted_haplo-identi.pdf';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';

function News() {
    return (
        <>
            <Header1 />
                <section className='blog-wrapper news-wrapper section-padding'>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-md-12">
                                <div className="news-content"  >
                                <div className="download-brochure w-100">
                                        <div className="brochure-heading" style={{backgroundColor:"#caebfd"}}>
                                            <span style={{fontSize: "24px", color:"#240661"}}><b>Publications</b></span>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF1} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}>
                                                <img src={Download} className="download-img" />Px GCSF PDF DEC 2017
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF2} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}  >
                                                <img src={Download} className="download-img"  />NH Publications on Unstable Haemoglobin diseases
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF3} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}   >
                                                <img src={Download} className="download-img"  />AISWAL_et_al_Cytotherapy2017_onlyCD56-enriched donor cell infus
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF4} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}  >
                                                <img src={Download} className="download-img"  />Rel-Poster Dr. Bansal Mumbai
                                            </a>
                                        </div>
                                        <div className="brochure-body">
                                            <a href={PDF5} style={{width:"88%", padding: "9px 20px", fontSize: "15px", fontWeight:"600", lineHeight: "1.1112", borderRadius: "4px"}}    >
                                                <img src={Download} className="download-img"  />Outcome_in_allogeneic_T_cell_depleted_haplo-identi
                                            </a>
                                        </div>
                                        <div className="brochure-footer"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            <Footer1 />
        </>
    );
}

export default News;
